define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-style",
	"dijit/form/ComboButton",
	"csi/_base/underscore",
	"csi/locale",
	"../SvgShapePalette",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(declare,lang,domClass,style,ComboButton,_,locale,SvgShapePalette,_Plugin,PluginFactory, util) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		iconClass: "csiActionIcon svgIconShapeRect",
		title: "CanvasCropImage",
		pluginName: "CanvasCropImage",

        /**
		 * The styling of the widget makes the focusNode cover titleNode, so apply title to focusNode too
		 */
		startup: function() {
			this.dropDown = new SvgShapePalette({
	            onChange: lang.hitch(this, this.onChangeShape)
			});

			this.inherited(arguments);
		},

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set("checked", this.editor.isCropPictureMode());

			if (this.editor.shapesArePictures(shapes, false)) {
				let value;
				if (this.propertyKey) {
					value = this.editor.canvasApp.selection.getCommonValue(shapes, this.propertyKey);
	
					if (!value) {
						value = "rect";
					}
				} else {
					value = this.editor.getStorageProperty("shapeProperties.spPr.geometry.presetShape") || "rect";
				}
				this.dropDown.initValueByType(value);
				return true;
			}

			return false;
		},

		/**
		 * Update current color and apply to shapes
		 * @param  {Object} value
		 */
		onChangeShape: function(shape) {
			this.editor.canvasApp.pageApi().changeShapeType(shape.shapeType);

			// nothing to do if already in crop mode
			if (!this.editor.isCropMode()) {
				this.editor.editPageObject();
			}
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			// If shape is currently custom, revert to rectangle if they click "crop to shape" menu
			if (this.editor.canvasApp.selection.isSelectedShapeCustom()) {
				this.editor.canvasApp.pageApi().changeShapeType("rect");
			}
			this.editor.editPageObject();
		}
	});
});